module.exports = __webpack_public_path__ + "media/images/admin/icons/moon-a82cae44d086a825a6fa3dfb65dce3ba.svg";